<template>
  <div
    class="row no-gutters"
    style="font-size: 0.6em; background: none"
    v-if="legend"
  >
    <template v-if="legend.colorizer.interp == 'exact'">
      <div
        v-if="legendTitle"
        class="col-sm-12"
        style="
          text-align: left;
          padding-bottom: 2px;
          font-weight: 600;
          color: #222;
        "
      >
        <span v-if="isBackground" style="float: right; color: #888"
          ><i class="bi bi-back"></i>&nbsp;Background</span
        >
        {{ legendTitle }}
        <span v-if="legendUnits">[{{ legendUnits }}]</span>
      </div>

      <ExactItem
        v-for="item in legendAsList"
        v-bind:item="item"
        v-bind:layout="layout"
        :key="item.label"
      />
    </template>

    <template v-if="legend.colorizer.interp == 'linear'">
      <div
        class="col-sm-12"
        style="
          text-align: left;
          padding-bottom: 5px;
          font-weight: 600;
          color: #222;
        "
      >
        <span v-if="isBackground"><i class="bi bi-back"></i>&nbsp;</span>
        {{ legendTitle }} [{{ legendUnits }}]
      </div>

      <!--<div v-if="legendHistogram" class="col-sm-7 text-right"><span style=";border-radius:2px;font-size:0.9em;padding:0px 5px;color:#aaa;">Histogram shows frequency of occurance</span></div>-->

      <div v-if="legendHasHistogram" class="histogram">
        <HistogramItem
          v-for="item in this.legendHistogram"
          v-bind:item="item"
          v-bind:legendHistogramMax="legendHistogramMax"
          :key="item.item"
        />
      </div>

      <div class="colormap">
        <div v-bind:style="bgStyle"></div>
      </div>

      <div class="labels">
        <LinearItem
          v-for="(item, index) in legend.colorizer.labels"
          v-bind:numItems="legend.colorizer.labels.length"
          v-bind:item="item"
          v-bind:index="index"
        />
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import _ from "lodash";

const HistogramItem = Vue.component("histogram-item", {
  props: ["item", "legendHistogramMax"],
  data() {
    return {};
  },
  template: `
      <div v-bind:style="style"></div>
    `,
  computed: {
    style() {
      var height = parseInt(50 * (this.item / this.legendHistogramMax));
      var margin = 50 - height;
      return (
        "background-color:#ccc;margin-top:" +
        margin +
        "px;height:" +
        height +
        "px;flex-basis: 100%;"
      );
    },
  },
});

const ExactItem = Vue.component("exact-item", {
  props: ["item", "layout"],
  data() {
    return {};
  },
  template: `
      <div v-bind:class="itemClass">
        <div class="label-exact" style="padding-right:5px;padding-top:5px;padding-left:35px;padding-bottom:5px;text-indent:-35px;
  color:#666;margin-bottom:0px;line-height:1.4em;border-top:0px solid #e5e5e5;">
          <span v-bind:style="style"><span style="height:1px;width:30px;display:inline-block;"></span></span>
          <span>{{label}}</span>
         </div>
      </div>
    `,
  computed: {
    style() {
      return (
        "background-color:" +
        this.item[1] +
        ";display:inline;width:35px;border:1px solid #888;text-align:center;"
      );
    },
    label() {
      return this.item[2];
    },
    itemClass() {
      return "col-sm-" + (this.layout ? 12 / this.layout.legendCols : 12);
    },
  },
});

const LinearItem = Vue.component("linear-item", {
  props: ["item", "index", "layout", "numItems"],
  data() {
    return {};
  },
  template: `
    <div v-bind:style="styleOuter">
        <div v-bind:style="styleInner"><nobr>{{item}}<nobr></div>
    </div>
  `,
  computed: {
    perc() {
      return parseInt(100 * (this.index / (this.numItems - 1)));
    },
    styleOuter() {
      if (this.perc == 0) {
        return "width:60px;display:block;position:absolute;left:0%;border-left:1px solid #000;padding:5px 0px 0px 0px;";
      }
      if (this.perc == 100) {
        return "display:block;position:absolute;right:0%;border-right:1px solid #000;padding:5px 0px 0px 0px;width:60px;text-align:right";
      }
      return (
        "width:60px;display:block;position:absolute;left:" +
        this.perc +
        "%;border-left:1px solid #000;padding:5px 0px 0px 0px;"
      );
    },
    styleInner() {
      if (this.perc == 0) {
        return "display:block;position:relative;left:-5px;top:20px;width:60px;text-align:left;background:none;;padding:0px 0px 0px 4px;";
      }
      if (this.perc == 100) {
        return "display:block;position:relative;right:0px;top:20px;width:60px;text-align:right;background:none;padding:0px;";
      }

      return "display:block;position:relative;left:-30px;top:20px;width:60px;text-align:center;background:none;padding:0px;";
    },
  },
});

export default {
  name: "RasterMapLegend",
  components: { ExactItem, LinearItem, HistogramItem },
  props: ["legend", "layout", "loaded", "isBackground"],
  data() {
    return {};
  },
  computed: {
    legendAsList() {
      if (this.legend) {
        if (this.legend.colorizer.interp == "exact") {
          // equal number of ranges as colormap items
          return _.zip(
            this.legend.colorizer.ranges,
            this.legend.colorizer.colormap,
            this.legend.colorizer.labels
          );
        }
      }
    },
    legendHasHistogram() {
      if (_.get(this.legend, "stats.histogram") != undefined) {
        return true;
      } else {
        return false;
      }
    },
    legendHistogram() {
      return _.get(this.legend, "stats.histogram.counts");
    },
    legendHistogramMax() {
      return _.max(this.legendHistogram);
    },
    legendTitle() {
      return _.get(this.legend, "title");
    },
    legendUnits() {
      return _.get(this.legend, "units", null);
    },
    gradientImage() {
      return this.legend.colormap_gradient;
    },
    bgStyle() {
      return (
        "height:20px;border:1px solid #000;margin:0 0px;padding:0px;background-color:#fc3;background-image:url(" +
        this.gradientImage +
        ");background-size:102%;background-position:center;"
      );
    },
  },
};
</script>

<style scoped>
div.histogram {
  color: #000;
  margin: 0px 0px;
  height: 50px;
  width: 100%;
  display: flex;
}
div.labels {
  display: block;
  position: relative;
  color: #000;
  top: -20px;
  width: 100%;
  height: 35px;
}
div.colormap {
  display: block;
  color: #000;
  position: relative;
  top: 0px;
  width: 100%;
}
</style>
